import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { FieldErrors, UseFormRegister } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ITrailer } from '../../../shared/interfaces/ITrailer';

interface IProps {
  register: UseFormRegister<ITrailer>;
  errors: FieldErrors<ITrailer>;
}
const TrailerForm = ({ errors, register }: IProps) => {
  const { t } = useTranslation();
  return (
    <Row>
      <Col md={6}>
        <Form.Group className="mb-3" controlId="form.licensePlate">
          <Form.Label>{t('general.licensePlate')}</Form.Label>
          <Form.Control
            type="text"
            placeholder={t('general.licensePlate')}
            isInvalid={!!errors.licensePlate}
            {...register('licensePlate')}
          />
          {errors?.licensePlate && (
            <Form.Control.Feedback type="invalid">
              {errors.licensePlate.message}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      </Col>

      <Col md={6}>
        <Form.Group className="mb-3" controlId="form.technicalInspection">
          <Form.Label>{t('general.technicalInspection')}</Form.Label>
          <Form.Control
            type="date"
            placeholder={t('general.technicalInspection')}
            isInvalid={!!errors.technicalInspection}
            {...register('technicalInspection')}
          />
          {errors?.technicalInspection && (
            <Form.Control.Feedback type="invalid">
              {errors.technicalInspection.message}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      </Col>

      <Col md={6}>
        <Form.Group className="mb-3" controlId="form.frc">
          <Form.Label>{t('general.frc')}</Form.Label>
          <Form.Control
            type="date"
            placeholder={t('general.frc')}
            isInvalid={!!errors.frc}
            {...register('frc')}
          />
          {errors?.frc && (
            <Form.Control.Feedback type="invalid">
              {errors.frc.message}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      </Col>
    </Row>
  );
};

export default TrailerForm;
